import MaterialPropertyAssigner from "../../../output/assets/materials/material-property-assigner.js";

class ThreeMaterialPrimitiveAssigner extends MaterialPropertyAssigner {
    constructor(defaultValues, updatingProps) {
        super();

        this._defaultValues = defaultValues;
        this._updatingProps = new Set(updatingProps);
    }

    setProperty(material, property, value) {
        if (value === undefined) {
            value = this._defaultValues[property];
        }

        if (this._updatingProps.has(property)) {
            let oldValue = material[property];
            if (oldValue === undefined) {
                oldValue = this._defaultValues[property];
            }

            if (value !== oldValue) {
                material.needsUpdate = true;
            }
        }

        material[property] = value;
    }
}

export default ThreeMaterialPrimitiveAssigner;
